import {Fragment, useEffect, useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {userApi} from 'api';
import {PageHeader, Tabs, Tab} from 'components';
import {useApiData} from 'hooks';
import {TRANSLATION_KEYS} from 'locale';
import {userAuthUtils} from 'utils';

import {UsersAudit} from './UserAudit';
import {UsersAvailability} from './UsersAvailability';
import {UsersList} from './UsersList';

const T_KEYS = TRANSLATION_KEYS.USER.ACCOUNT.USERS;

export const Users: React.FC = (() => {
    const {t} = useTranslation();
    const {currentInfo, audit, availability} = useMemo(() =>
        userAuthUtils.getUserPermissions().account.users, []);

    const {
        send: fetchUsers,
        data: usersData = {users: [], count: 0, isMaxUsersCountExceeded: true},
        initialData,
        loading: usersLoading,
    } = useApiData(userApi.getUsers);

    useEffect(() => {
        fetchUsers();
    }, [fetchUsers]);

    return (
        <Fragment>
            <PageHeader title={t(T_KEYS.TITLE)} />
            <Tabs overflow={false}>
                <Tab name={t(T_KEYS.CURRENT_USERS.TITLE)} hidden={!currentInfo?.enabled}>
                    <UsersList
                        initialUsersData={initialData?.users}
                        usersLoading={usersLoading}
                        fetchUsers={fetchUsers}
                        {...usersData}
                    />
                </Tab>
                <Tab name={t(T_KEYS.USERS_AUDIT.TITLE)} hidden={!audit?.enabled}>
                    <UsersAudit users={initialData?.users} />
                </Tab>
                <Tab name={t(T_KEYS.USERS_AVAILABILITY.TITLE)} hidden={!availability?.enabled}>
                    <UsersAvailability />
                </Tab>
            </Tabs>
        </Fragment>
    );
});